import React from 'react';
import { Link } from 'react-router-dom';


export default function() {
    return (
        <footer>
            <Link to='/rules'>Правила оплаты</Link> - <Link to='/public_offer'>Публичная оферта</Link>
            <br />
            <Link to='/support'>Поддержка пользователей</Link>
            <br />
            Copyright &copy; {new Date().getFullYear()} &nbsp;
            <a href='https://kudago.com' style={{textDecoration: 'none'}}>
                <img className='logo' alt="KudaGo.com" src={process.env.PUBLIC_URL + '/kudago.favicon.png'} />
                &nbsp;&nbsp;
                <span style={{textDecoration: 'underline'}}>KudaGo.com</span>
            </a>
        </footer>
    );
}
